var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector37(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7203 0.00299835C7.91533 0.15002 8.13136 0.273037 8.30238 0.444062C10.4237 2.55336 12.536 4.67167 14.6513 6.78397C14.8583 6.991 15.0113 7.21303 14.9993 7.52207C14.9873 7.87612 14.8193 8.13116 14.5133 8.28718C14.2042 8.44321 13.8952 8.4132 13.6101 8.20917C13.5141 8.14016 13.4331 8.05315 13.3491 7.96914C11.4768 6.09987 9.60757 4.2306 7.7383 2.35834C7.66629 2.28632 7.60928 2.20531 7.52827 2.1033C7.42326 2.20531 7.34524 2.27432 7.27023 2.34933C5.36796 4.25461 3.46569 6.15688 1.56342 8.05915C1.03534 8.58423 0.261233 8.4342 0.0482027 7.76511C-0.0598127 7.43206 0.015198 7.13202 0.258233 6.88298C0.555275 6.57394 0.861319 6.2739 1.16436 5.97085C3.00363 4.13159 4.83689 2.29233 6.68215 0.459064C6.85918 0.282039 7.08121 0.15302 7.28224 -1.90735e-06H7.7203V0.00299835Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector37);
export default __webpack_public_path__ + "static/media/Vector (37).722bbbf350a5ddf91dedb9c1ee57977d.svg";
export { ForwardRef as ReactComponent };